import { useEffect, useRef } from 'react';
const useObserveHtmlClass = (className, callback) => {
  const observerRef = useRef(null);
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    const targetNode = document.querySelector('html');
    if (!targetNode) return;
    const handleClassChange = mutationList => {
      mutationList.forEach(() => {
        const classNames = targetNode.getAttribute('class');
        if (classNames) {
          callbackRef.current(classNames.includes(className));
        }
      });
    };
    observerRef.current = new MutationObserver(handleClassChange);
    observerRef.current.observe(targetNode, {
      childList: false,
      attributes: true,
      attributeFilter: ['class']
    });
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [className]);
};
export default useObserveHtmlClass;